"use strict";
exports.__esModule = true;
exports.isPostcode = exports.isUkPostcode = void 0;
var postcodePattern = '^[a-z0-9\\s]+$';
var ukPostcodePattern = '^' +
    '(' +
    '(GIR 0AA)' +
    '|' +
    '(' +
    '(' +
    '([A-Z][0-9]{1,2})' +
    '|' +
    '(' +
    '([A-Z][A-HJ-Y][0-9]{1,2})' +
    '|' +
    '(' +
    '([A-Z][0-9][A-Z])' +
    '|' +
    '([A-Z][A-HJ-Y][0-9]?[A-Z])' +
    ')' +
    ')' +
    ')' +
    '\\s*' + // Notice double escape here
    '[0-9][ABD-HJLNP-UW-Z]{2}' +
    ')' +
    ')' +
    '$';
var ukPostcodeExpression = new RegExp(ukPostcodePattern, 'gi');
var postcodeExpression = new RegExp(postcodePattern, 'gi');
function isUkPostcode(value) {
    return value.match(ukPostcodeExpression) !== null;
}
exports.isUkPostcode = isUkPostcode;
function isPostcode(value) {
    return value.match(postcodeExpression) !== null;
}
exports.isPostcode = isPostcode;
//# sourceMappingURL=postcode.js.map